<section class="p-10 bg-ayr-white dark:bg-ayr-black text-ayr-black dark:text-ayr-white overflow-hidden">
    <div class="text-15 lg:text-18 max-w-960 m-auto space-y-12">
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12 sm:col-span-5 max-w-[368px]">
                <h2 class="text-27 lg:text-47 font-bold leading-none lg:leading-tight">
                    <span class="ayr-underline dark:text-shadow  ">{{
                        "cities.revitalized-container.header.revitalized" | translate
                        }}</span>
                    <br />
                    <span>
                        {{"cities.revitalized-container.header.competitive" | translate}}
                        <br />
                        {{ "cities.revitalized-container.header.cities" | translate }}
                    </span>
                </h2>

                <p class="mt-7 leading-5 lg:leading-normal">
                    {{ "cities.revitalized-container.content.first" | translate }}
                    {{ "cities.revitalized-container.content.second" | translate }}
                    {{ "cities.revitalized-container.content.third" | translate }}
                    {{ "cities.revitalized-container.content.fourth" | translate }}
                </p>
            </div>
            <picture class="hidden md:inline-block col-start-6 col-end-9 self-end">
                <source
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x.avif"
                    type="image/avif">
                <img
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x.webp"
                    alt="ayr_citizens" loading="lazy">
            </picture>
            <picture class="hidden sm:inline-block sm:col-start-8 md:col-start-9 col-end-13 self-end mb-8">
                <source
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x (1).avif"
                    type="image/avif">
                <img
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-3@2x (1).webp"
                    alt="ayr_citizens" loading="lazy">
            </picture>
        </div>

        <div class="grid grid-cols-12 gap-4 text-right">
            <picture class="hidden sm:inline-block col-start-2 col-end-6 w-full">
                <source
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-2@2x.avif"
                    type="image/avif">
                <img
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-2@2x.webp"
                    alt="ayr_citizens" loading="lazy">
            </picture>
            <div class="col-start-1 sm:col-start-8 col-end-13 max-w-[368px] justify-self-end">
                <h2 class="text-27 lg:text-47 font-bold leading-none lg:leading-tight">
                    <span>
                        {{ "cities.accelerate-container.header.accelerate" | translate }} <br />
                        {{ "cities.accelerate-container.header.local-economy" | translate }} {{
                        "cities.accelerate-container.header.through" | translate }} <br />
                    </span>
                    <span class="ayr-underline dark:text-shadow  ">
                        {{ "cities.accelerate-container.header.air" | translate }} {{
                        "cities.accelerate-container.header.quality" | translate }}
                    </span>
                </h2>

                <div class="mt-7 leading-5 lg:leading-normal">
                    <p>{{ "cities.accelerate-container.content.more-jobs" | translate }}</p>
                    <p>{{ "cities.accelerate-container.content.more-quality" | translate }}</p>
                    <p>{{ "cities.accelerate-container.content.modernization" | translate }}</p>
                </div>
            </div>
        </div>


        <div class="grid grid-cols-12 gap-4 relative pb-11">
            <div class="col-span-12 sm:col-span-7 max-w-[475px]">

                <h2 class="text-27 lg:text-47 font-bold leading-none lg:leading-tight">
                    <span>{{ "cities.create-container.header.create" | translate }} {{
                        "cities.create-container.header.new" | translate }}</span> <br />
                    <span class="ayr-underline dark:text-shadow"> {{ "cities.create-container.header.sustainable-projects" | translate }}</span>
                </h2>
                <p class="mt-7 max-w-[346px]">
                    {{ "cities.create-container.content.first" | translate }} {{
                    "cities.create-container.content.second" | translate }} {{
                    "cities.create-container.content.third" | translate }} {{
                    "cities.create-container.content.fourth" | translate }} {{
                    "cities.create-container.content.fifth" | translate }} {{
                    "cities.create-container.content.sixth" | translate }}
                </p>
            </div>
            <picture class="hidden sm:inline-block absolute col-start-8 col-end-13 mt-28">
                <source
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-6@2x.avif"
                    type="image/avif">
                <img
                    src="https://storage.googleapis.com/weayr-assets-non-prod/images/citizens/pedro-menezes-OSCabJzBru0-unsplash-6@2x.webp"
                    alt="ayr_citizens" loading="lazy">
            </picture>
        </div>

    </div>
</section>